import axios from "axios";
import { APP_SETTINGS } from "../../config";

export function getAllOrganizationsApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.ORGANIZATION.getAllOrganiazations,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}
export function createOrganizationsApi(data, token) {
  return axios.post(
    APP_SETTINGS.API_PATH.ORGANIZATION.craeteOrganization,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
}

export function editOrganizationsApi(data, token) {
  return axios.post(APP_SETTINGS.API_PATH.ORGANIZATION.editOrganization, data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function deleteOrganizationsApi(id, token) {
  let url = `${APP_SETTINGS.API_PATH.ORGANIZATION.deleteOrganization}?organizationId=${id}`;
  return axios.delete(url, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
}

export function activeOrganizationsApi(data) {
  return axios.post(
    APP_SETTINGS.API_PATH.ORGANIZATION.activeOrganization,
    data
  );
}
export function setUserOrganizationsApi(params, token) {
  return axios.get(APP_SETTINGS.API_PATH.ORGANIZATION.setUserOrganization, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params,
  });
}
